export default "__VITE_ASSET__DuxMnMIZ__"